module.exports = __webpack_public_path__ + "static/media/files icon-video.6c9c6b61.png";